module.exports = __webpack_public_path__ + "static/media/icircle.1322459d.svg";